import React from 'react';
import '../styles/base/animations.css';

const LoadingBanner = () => {
  return (
    <div className="loading-banner">
      <div className="loading-dots">
        <span />
        <span />
        <span />
      </div>
      <div className="loading-banner-label">Loading...</div>
    </div>
  );
};

export default LoadingBanner;
